import { BalanceType, FiatCurrencyLabel } from '@libs/types';
export const convertAssetLabel = (code) => {
    if (code === BalanceType.BGEL) {
        return FiatCurrencyLabel.BGEL;
    }
    else if (code === BalanceType.BUSD) {
        return FiatCurrencyLabel.BUSD;
    }
    return code;
};
//# sourceMappingURL=convertAssetLabel.js.map